(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  var forms = document.querySelectorAll('.product-card-wrapper form');
  forms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      var btn = form.querySelector('.product-card-submit-btn');
      if (btn) {
        btn.disabled = true;
        var text = btn.querySelector('.product-card-btn-text');
        var loader = btn.querySelector('.product-card-btn-loader');
        if (text) text.classList.add('hidden');
        if (loader) loader.classList.remove('!hidden');
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
